import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";
import { trackEvent } from "../lib/seo";
import { HOME_CHALLENGES } from "../lib/site";

const HomeChallenge = () => (
    <section
        data-testid="home-challenge-section"
        className="relative border-y border-white/10 bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    THE HOMEOWNER CHALLENGE
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    C.01 — C.04
                </p>
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="challenge-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
            >
                Building a home is complicated. Understanding it shouldn't be
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4"
            >
                {HOME_CHALLENGES.map((c) => (
                    <motion.div
                        key={c.code}
                        variants={fadeUp}
                        data-testid={`challenge-card-${c.code.toLowerCase().replace(".", "-")}`}
                        className="flex flex-col border border-white/12 bg-surface/80 px-7 py-8"
                    >
                        <span className="font-mono text-[13px] tracking-[0.22em] text-accent">
                            {c.code}
                        </span>
                        <h3 className="mt-6 font-mono text-[13px] tracking-[0.24em] text-white">
                            {c.title}
                        </h3>
                        <p className="mt-4 flex-1 text-[15px] leading-relaxed text-mist">
                            {c.copy}
                        </p>
                    </motion.div>
                ))}
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-14 flex flex-col gap-6 border-t border-white/10 pt-10 md:flex-row md:items-center md:justify-between"
            >
                <p
                    data-testid="challenge-closing-line"
                    className="max-w-xl font-display text-xl font-semibold leading-snug text-white md:text-2xl"
                >
                    You don't have to navigate the building process blindly
                    <span className="text-accent">.</span>
                </p>
                <Link
                    to="/how-it-works"
                    data-testid="challenge-help-cta"
                    onClick={() => trackEvent("cta_click", "challenge_discover_help")}
                    className="group inline-flex shrink-0 items-center gap-2 border border-white/25 px-6 py-3.5 text-[15px] font-medium text-white transition-colors duration-300 hover:border-accent"
                >
                    Discover How BuildEase Helps
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                </Link>
            </motion.div>
        </div>
    </section>
);

export default HomeChallenge;
